import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    user: {}
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.SUCCESSFULLY_CHECKAUTH:
        return Object.assign({}, state, { user: action.user });
    case types.FAILED_CHECKAUTH:
        return Object.assign({}, state, { error: action.error, hasError: true });
    default:
        return Object.assign({}, state);
    }
};

export default reducer;
